import { render, staticRenderFns } from "./PanelDashboard.vue?vue&type=template&id=044bec92&"
import script from "./PanelDashboard.vue?vue&type=script&lang=js&"
export * from "./PanelDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports